import styled from '@emotion/styled';
import { COLORS } from '../../../constants/radar';

export const ProfileContainer = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  background: transparent;
`;

export const ProfileContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  color: ${COLORS.PRIMARY};
  padding: 4px;
  border-radius: 24px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0px;
  margin-right: 8px;
`;

export const UserName = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: ${COLORS.PRIMARY};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
`;

export const UserEmail = styled.div`
  color: ${COLORS.SECONDARY};
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
`;

export const UserPosition = styled.div`
  font-size: 12px;
  color: ${COLORS.SECONDARY};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
`;